<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-icon class="mr-1" color="green">mdi-account</v-icon>
            Admin
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToAddAdmin">
                + ADD
            </v-btn>
        </v-card-title>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteGroup">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- table list -->
        <v-data-table :headers="headers" :items="userList" :search="search" sort-by="firstname" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading" class="table-striped elevation-1">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.avatar" size="32" class="mr-2">
                    <img :src="item.avatar" />
                </v-avatar>
                <v-avatar v-else color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
            </template>
            <!-- <template v-slot:[`item.orgText`]="{ item }">
                {{ orgHash[item.orgId] }}
            </template> -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click="goToEditUser(item)" title="Edit">
                    mdi-pencil
                </v-icon>
                <v-icon class="mr-2" @click="dialogDeleteUser(item)" title="Delete">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import formatData from "../utils/formatData";
import getUserList from "../data/getUserList";
import setUserInfo from "../data/setUserInfo";
import getOrgList from "../data/getOrgList";
import {
    mapGetters
} from "vuex";
export default {
    name: 'ChallengeAdmin',
    metaInfo: {
        title: 'Challenge Admin'
    },
    data() {
        return {
            search: "",
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "Name",
                    value: "name",
                },
                {
                    text: "Phone Nmber",
                    value: "phoneNumber",
                },
                {
                    text: "Organization Name",
                    value: "orgText",
                },
                {
                    text: "Role",
                    value: "roleText",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            userList: [],
            roleList: [{
                    challengeAdmin: "Admin"
                },
                {
                    superAdmin: "Super Admin"
                }
            ],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this user?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this user?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            orgHash: {},
            loading: false
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            if( this.isSuperAdmin ){
                (async () => {
                    this.userList = await getUserList("getAdminUser");

                    var orgList = await getOrgList();
                    orgList.forEach((v) => {
                        if( v.name != undefined ){
                            this.orgHash[v.id] = v.name;
                        }
                    });
                    if( this.userList.length ){
                        this.userList.forEach((user) => {
                            if( user['orgId'] != undefined ){
                                user['orgText'] = this.orgHash[user['orgId']];
                            }
                        });
                    }
                    this.loading = false;
                })();
            }
            else{
                this.$router.push(`/dashboard`);
            }
        },
        dialogDeleteUser(item) {
            this.dialogItem.deleteConfirmation = true;
            this.dialogItem.deletedItemId = item.uid;
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteGroup() {
            if (this.dialogItem.deletedItemId) {
                (async () => {
                    await setUserInfo(this.dialogItem.deletedItemId, {
                        role: ""
                    });
                    this.dialogItem.deleteConfirmation = this.dialogItemDefault.deleteConfirmation;
                    this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
                    this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
                    this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId;
                    this.initialize();
                })();
            }
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId;
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToEditUser(item) {
            this.$router.push(`/user/edit/${item.uid}`);
        },
        goToAddAdmin() {
            this.$router.push(`/user/add`);
        }
    },
};
</script>